class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (event) => {
      if (event.code === "Escape") this.close();
    });

    const overlay = this.querySelector("#CartDrawer-Overlay");
    if (overlay) {
      overlay.addEventListener("click", this.close.bind(this));
    }

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink) return;

    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");

    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    this.classList.add("animate", "active");
    document.body.classList.add("overflow-hidden");

    const focusContainer = this.querySelector(".drawer__inner") || this;
    const focusElement = this.querySelector(".drawer__close") || focusContainer;

    if (typeof trapFocus === "function") {
      try {
        trapFocus(focusContainer, focusElement);
      } catch (e) {
        console.warn("trapFocus error (ignored):", e);
      }
    }
  }

  close() {
    this.classList.remove("active");
    document.body.classList.remove("overflow-hidden");

    if (typeof removeTrapFocus === "function" && this.activeElement) {
      try {
        removeTrapFocus(this.activeElement);
      } catch (e) {
        console.warn("removeTrapFocus error (ignored):", e);
      }
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: "#CartDrawer"
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section"
      }
    ];
  }

  renderContents(parsedState) {
    try {
      const sections = this.getSectionsToRender();

      sections.forEach(({ id, section, selector }) => {
        const sectionHTML = parsedState.sections?.[section];
        if (!sectionHTML) return;

        const newDom = new DOMParser().parseFromString(sectionHTML, "text/html");
        const newContent = newDom.querySelector(selector);
        const currentContainer =
          document.getElementById(id) || document.querySelector(selector);

        if (newContent && currentContainer) {
          currentContainer.innerHTML = newContent.innerHTML;
        }
      });

      // toggle empty class on <cart-drawer>
      if (typeof parsedState.item_count === "number") {
        this.classList.toggle("is-empty", parsedState.item_count === 0);
      }

      this.open();
    } catch (e) {
      console.error("CartDrawer.renderContents error", e);
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

// Drawer quantity changes (+/-) reuse existing CartItems logic
class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: "#CartDrawer"
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section"
      }
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
